<template>
   <div
    class="cs_master_template heading"
    :class="productID ? `sing-product single_${productID}` : ''"
    >
        <BannerButton v-if="data_banner" :bannerDataProp="data_banner" />

        <h1 class="hidden-title" v-if="title_seo && ! data_banner?.title && isPage !== 'single-product'">{{ title_seo }}</h1>
        <div class="master-template-sections text-center">
            <template v-for="(item, index) in master_template" :key="index">
                <ItemDoubleColumn v-if="item.layout === 'doubleCol'" :data="item.columns" />
                <SingleColumn v-if="item.layout === 'singleCol'" :data="item.columns" />
                <BannerButton v-if="item.layout === 'banner'" :bannerDataProp="item.banner" />
                <ItemTripleColumn v-if="item.layout === 'tripleCol'" :data="item.columns" />
                <IconRow v-if="item.layout === 'iconsRow'" :data="item.icons" />
                <ItemTextLeftRight v-if="item.layout === 'textLeft' || item.layout === 'textRight'" :data="item.columns" />
                <ItemDoubleColumnCta v-if="item.layout === 'doubleColCTA'" :data="item.doubleColCTA" :data_item="data_product_item"  />
                <ItemCrouselLayout v-if="item.layout === 'CarouselLayout'" :data="item.slides" :data_item="data_product_item" :data_index = "index" />
                <Information v-if="item.layout === 'slider'" :data="item.items" />
                <FormMaster v-if="item.layout === 'appointmentForm' && item.slug === 'ear-piercing'"
                    :data_title="item.form_title"
                    :data_description="item.form_description"
                    :data_key="item.site_key"
                    :data_postId="item.post_id"
                    :data_store="item.store"
                />
                <FormAmbassador v-if="item.layout === 'customForm' && item.form_type === 'ambassadorForm'"
                    :data_title="item.form_title"
                    :data_description="item.form_description"
                    :data_key="item.site_key"
                    :data_postId="item.post_id"
                />
                <ItemReviews v-if="item.layout === 'reviews'" :data="item.columns" />
                <MasterTabToggle v-if="item.layout === 'ToggleTabLayout'" :data="item.tabs" :data_item="data_product_item"/>
            </template>
            <Faqs v-if="list_faq && list_faq.faqs_items"
                :option_faqs="option_faqs.style"
                :data="list_faq"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import SingleColumn from "./SingleColumn.vue";
import ItemTextLeftRight from "./ItemTextLeftRight.vue";
import ItemDoubleColumn from "./ItemDoubleColumn.vue";
import ItemTripleColumn from "./ItemTripleColumn.vue";
import ItemDoubleColumnCta from "./ItemDoubleColumnCta.vue";
import MasterTabToggle from './MasterTabToggle.vue';
import FormAmbassador from "./FormAmbassador.vue";
import FormMaster from "./FormMaster.vue";
import ItemCrouselLayout from "./ItemCrouselLayout.vue";
import ItemReviews from "./ItemReviews.vue";
import Faqs from "~/components/Product/SingleProduct/Faqs.vue";
import BannerButton from "~/components/Campaign/BannerButton.vue";
import IconRow from "./IconRow.vue";
import Information from "~/components/Product/SingleProduct/Information.vue";
import type { IProductItem } from "~/types/productItem";
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const { $ajax } = useNuxtApp();
const props = defineProps(["data", 'isPage','productID']);
const data_banner = computed(() => props.data?.data?.banner || []);
const title_seo = computed(() => props.data?.data?.title_seo || "");
const master_template = computed(() => props.data?.data?.layouts || []);
const data_product_item = ref([]);
// const data_product_item = computed(() => props.data?.data?.product_section_ids || []);
const data_product_list_item = computed(() => props.data?.data?.product_section_ids || []);
const data_list_product = computed(() => props.data?.data?.list_product_ids || []);
const list_faq = computed(() => props.data?.data?.faq || []);
const heading_faq = computed(() => props.data?.data?.faq?.heading || '');
const userStore = useUserStore();
interface IProductResponse{
    success: boolean;
    data: IProductItem[];
}

const getRecentlyViewedProducts = async () => {
    const productIds = Object.values(data_list_product.value).join(',');
    try {
        if (data_list_product.value){
            const { data: listData } = await useAsyncData<IProductResponse>(
                'listData',
                async () => {
                    return $ajax.get(`${runtimeConfig.public.API_URL}productids/${productIds}`, {
                        headers: {
                        'X-API-Key': userStore.csrf,
                        'X-API-Server': userStore.csrf_server
                        }
                    });
                }
            );
            if(listData.value?.success){
                Object.keys(data_product_list_item.value).forEach(key => {
                    const productArray = data_product_list_item.value[key];
                    if (productArray && Array.isArray(productArray)) {
                        listData.value.data.forEach(product => {
                            const existingProduct = productArray.find(
                                item => item.product_id === product.product_id
                            );
                            if (existingProduct) {
                                Object.assign(existingProduct, product);
                            }
                        });
                    }
                });
            }else{
                // Object.keys(data_product_list_item.value).forEach(key => {
                //     data_product_list_item.value[key] = [];
                // });
            }
        }
    } catch (e) {
        console.error("Error fetching recently viewed products:", e);
    }
    data_product_item.value = data_product_list_item.value;
};
if (data_list_product.value && data_list_product.value.length > 0) {
    getRecentlyViewedProducts();
}
const option_faqs = {
    type: 1,
    style: {
        item: {
            background: '',
            hoverBackground: '',
            textColor: '#000',
            hoverColor: '#ad073d',
            fontSize: '20px'
        },
        icon: {
            background: '#000',
        },
        content: {
            background: '',
            textColor: '#000',
            fontSize: '14px'
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/master-template/_master-template.scss";
@import "@/assets/scss/components/home/_heading.scss";

#page {
    background: #fbf8f8;
}

.hidden-title {
    display: none;
}

.cs_master_template .single-product__faq .single-product__faq-container {
    max-width: 1440px;
}

.cs_master_template .single-product__faq .single-product__faq-container h2 {
    margin-bottom: 25px;
}

.cs_master_template .master-section .img-fluid {
    height: auto !important;
}
.sing-product {
    .master-main-banner_image {
        margin-bottom: 60px;
    }
    .master-template-sections {
    .master-section {
        max-width: 100%;
    }
    }
    
} 
@media (min-width: 768px) {
        body .sing-product .pl-md-1, 
        body .sing-product .px-md-1 {
            padding-left: 0 !important;
            padding-right: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
    }
@media (max-width: 768px) {
    .sing-product [class^="col-"],
    #product .master-template-sections {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .sing-product {
        .master-main-banner_image {
            margin-bottom: 15px;
        }
    } 
  
}
</style>
